import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/index.js";
import { Loader2 } from "lucide-react";
export function Loading({ className, size = "md", variant = "white" }) {
    const sizeClass = {
        sm: "h-6 w-6",
        md: "h-8 w-8",
        lg: "h-12 w-12",
    }[size];
    const variantClass = {
        primary: "text-b3-react-primary",
        white: "opacity-50",
    }[variant];
    return (_jsx("div", { className: cn("relative", sizeClass, className), children: _jsx(Loader2, { className: cn("animate-spin", sizeClass, variantClass) }) }));
}
